import { useCallback, useEffect, useState } from 'react';
import { UnwrapPromise } from 'types/base';
import { OmsOrderDetail, OmsOrderMultiplePay } from 'types/oms';
import {
  getOmsOrderDetailById,
  getOmsOrderDetailV2,
  getOmsOrderMultiplePayList,
} from 'apis/oms';
import { ProductUpdateInfoNewType } from 'types/pms';
import { getProductUpdateInfoNew } from 'apis/pms';

export const useOrderDetail = (id?: number) => {
  const [omsOrderDetail, setOmsOrderDetail] = useState<OmsOrderDetail>();
  const [omsOrderDetailV2, setOmsOrderDetailV2] =
    useState<UnwrapPromise<ReturnType<typeof getOmsOrderDetailV2>>>();
  const [omsOrderMultiplePayList, setOmsOrderMultiplePayList] = useState<
    OmsOrderMultiplePay[]
  >([]);
  const [productList, setProductList] = useState<ProductUpdateInfoNewType[]>(
    [],
  );

  const reloadOrderDetailV2 = useCallback(() => {
    if (!id) return;
    getOmsOrderDetailV2(+id).then((res) => {
      setOmsOrderDetailV2(res);
    });
  }, [id]);

  useEffect(() => {
    if (!id) return;
    getOmsOrderDetailById(+id).then((res) => {
      setOmsOrderDetail(res.data);
    });
    reloadOrderDetailV2();
    getOmsOrderMultiplePayList(+id).then((res) => {
      setOmsOrderMultiplePayList(res);
    });
  }, [id, reloadOrderDetailV2]);

  useEffect(() => {
    if (!omsOrderDetail) return;
    const productIdList = omsOrderDetail.orderItemList.map((i) => i.productId);
    if (!productIdList.length) return;

    Promise.all(
      productIdList.map((productId) => {
        return getProductUpdateInfoNew(productId);
      }),
    ).then((i) => {
      setProductList(i);
    });
  }, [omsOrderDetail]);

  return {
    omsOrderDetail,
    omsOrderDetailV2,
    reloadOrderDetailV2,
    omsOrderMultiplePayList,
    productList,
  };
};
